/*
  AMOR "Skonfiguruj i kup" (snippets/am-config + am-config-size, 11.10.2026; modelled on the mybed.pl configurator).
  Full mode (products with options and custom.konfigurator): the product page shows the current configuration and a
  "Skonfiguruj i kup" button. The full-screen configurator: photos on the left (only the chosen fabric's photos, the
  alt text names the fabric), numbered steps on the right (size = sibling products, then the options from the JSON),
  a second tab with add-ons, and a bottom bar with the total, the delivery dates (amor.js fills [data-am-ship]) and
  "Dodaj do koszyka". Each tile shows the price difference against the cheapest choice and whether that combination
  is in stock. The chosen variant (of whichever size) and the ticked add-ons are posted as items[n] through a form,
  so assets/amor-cart.js adds them and shows its popup, as for any add-to-cart.
  Inline mode (add-ons only): add-on cards under the price; ticked add-ons join the product form's request.
  Add-ons are never pre-ticked (directive 2011/83/EU art. 22, Polish consumer rights act art. 10).
  Required choice (12.10.2026): add-ons flagged "q" (the stelaż, for beds sold without one) show two buttons,
  "Dodaj stelaż +price" and "Bez stelaża", with neither chosen. The bed goes to the cart only after the customer
  has picked one; until then "Dodaj do koszyka" points to the choice instead of adding. In the configurator the
  choice is a numbered step of the first tab; the decision is kept per stelaż variant, so a new size asks again.
  Product page price (12.10.2026): the price under the title follows the chosen add-ons and, with the configurator,
  the configured variant (of whichever size) plus its add-ons; the line under it lists the parts. assets/amor-cart.js
  paints that block (it also multiplies by the quantity); setPrice() only hands it the numbers.
  Photos (14.10.2026): loaded ahead of the click, the stage switches only to a ready photo (see warm()).
*/
(function () {
  'use strict';

  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // i18n (snippets/am-i18n, rendered by layout/theme.liquid): AMOR_I18N = strings in the page's language, AMOR_MKT =
  // the market's facts, AMOR_MONEY = amounts in another currency than złoty. The Polish text is the fallback.
  const T = (k, d) => { const v = (window.AMOR_I18N || {})[k]; return typeof v === 'string' && v ? v : d; };
  const F = (s, o) => String(s).replace(/\{(\w+)\}/g, (m, k) => (o[k] != null ? o[k] : m));
  const MKT = window.AMOR_MKT || {};
  const PL = String(document.documentElement.lang || 'pl').toLowerCase().slice(0, 2) === 'pl';
  // The frame under the mattress: "stelaż" (Polish), "rošt" (Czech, AMOR_I18N.cfg_frame_re); beds: "materac" / "matrac".
  // Required add-ons ("q": product tagged "stelaz") count as the frame on pages in another language too.
  const re = (k, d) => { try { return new RegExp(T(k, d), 'i'); } catch (e) { return new RegExp(d, 'i'); } };
  const FRAME = re('cfg_frame_re', 'stelaż');
  const BED = re('cfg_bed_re', 'materac');
  const isFrame = (a) => FRAME.test((a && a.t) || '') || (!PL && !!(a && a.q));
  const pln = (c) => {
    const x = window.AMOR_MONEY ? window.AMOR_MONEY(c || 0) : null;
    if (x != null) return x;
    c = Math.round(c || 0);
    const z = String(Math.floor(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const g = c % 100;
    return z + (g ? ',' + String(g).padStart(2, '0') : '') + ' zł';
  };
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const diff = (d) => (d > 0 ? '+' + pln(d) : d < 0 ? '−' + pln(-d) : pln(0));
  const num = (n) => String(Math.round(n * 10) / 10).replace('.', ',');
  const cssq = (s) => (window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/["\\]/g, '\\$&'));
  const TICK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  const CORNER = '<span class="amx-corner" aria-hidden="true">' + TICK + '</span>';
  const track = (name) => { try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {} };
  // "Stelaż pod materac, wkład do łóżka …" -> "stelaż pod materac" (a part in the line under the product price)
  const shortT = (t) => {
    const s = String(t || '').split(',')[0].trim();
    return /^\p{Lu}\p{Ll}/u.test(s) ? s.charAt(0).toLowerCase() + s.slice(1) : s;
  };
  // Hands the price block (#price-<section>) what the customer has chosen: x = {add, n, addSet, base, cmp, name,
  // items} (see assets/amor-cart.js), or null for the product alone. n / addSet: the chosen add-ons that count for
  // the set discount (furniture, "f": true from the Liquid; product type Akcesoria does not, 13.10.2026) and their
  // grosze per piece. amor-cart.js marks the block with data-am-qty and
  // repaints it on "amx:price"; without it (no quantity box) the amounts are written here, without the quantity.
  // Like the product page price (money_without_trailing_zeros, 13.10.2026, audit CON-06): grosze only when there are any.
  const money2 = (c) => pln(c);
  function setPrice(sid, x) {
    const box = document.getElementById('price-' + sid);
    if (!box) return;
    box.amxPrice = x;
    if (box.dataset.amQty) {
      box.dispatchEvent(new CustomEvent('amx:price'));
      return;
    }
    const keep = (n) => {
      if (n.dataset.amBase === undefined) {
        // "1.199 zł" or "1.804,05 zł" -> grosze (the grosze come only after a comma)
        const m = n.textContent.replace(/[^\d,]/g, '');
        const [a, b = ''] = m.split(',');
        n.dataset.amBase = String(/\d/.test(m) ? parseInt(a || '0', 10) * 100 + parseInt((b + '00').slice(0, 2), 10) : 0);
      }
      return Number(n.dataset.amBase) || 0;
    };
    box.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale').forEach((n) => {
      const v = x && x.base ? x.base : keep(n);
      if (v) n.textContent = money2(v + ((x && x.add) || 0));
    });
    if (!box.dataset.amxObs) {
      box.dataset.amxObs = '1';
      new MutationObserver(() => setPrice(sid, box.amxPrice)).observe(box, { childList: true });
    }
  }

  function addonHtml(a, on) {
    const vt = a.vt && a.vt !== 'Default Title' ? a.vt : '';
    return '<div class="amx-addon' + (on ? ' is-on' : '') + (a.av ? '' : ' is-out') + '">' +
      (a.img ? '<img src="' + esc(a.img) + '" alt="" width="96" height="72" loading="lazy">' : '<span class="amx-addon__img"></span>') +
      '<span class="amx-addon__t"><b>' + esc(a.t) + '</b><small>' + esc((vt ? vt + ' · ' : '') + (a.av ? T('cfg_one_delivery', 'w jednej dostawie z meblem') : T('cfg_unavail_n', 'chwilowo niedostępne'))) + '</small></span>' +
      '<span class="amx-addon__p">+' + pln(a.p) + '</span>' +
      '<button type="button" class="amx-addon__btn" data-addon="' + esc(a.id) + '" aria-pressed="' + on + '"' + (a.av ? '' : ' disabled') + '>' + (on ? TICK + T('cfg_added', 'Dodano') : T('cart_add', 'Dodaj')) + '</button>' +
      '</div>';
  }

  // Required choice: two buttons, none pressed until the customer clicks one (st: true = added, false = without).
  const reqWord = (a) => (isFrame(a) ? [T('cfg_add_frame', 'Dodaj stelaż'), T('cfg_no_frame', 'Bez stelaża'), T('cfg_frame', 'Stelaż')] : [T('cart_add', 'Dodaj'), T('cfg_no_addon', 'Bez dodatku'), a.t]);
  function reqHtml(a, st, err) {
    const vt = a.vt && a.vt !== 'Default Title' ? a.vt : '';
    const w = reqWord(a);
    const id = esc(a.id);
    const btn = (val, on, label) => '<button type="button" class="amx-choice__b" data-req="' + id + '" data-req-v="' + val + '" aria-pressed="' + on + '">' + (on ? TICK : '') + label + '</button>';
    return '<div class="amx-addon amx-addon--req' + (st === true ? ' is-on' : '') + (err ? ' is-err' : '') + (a.av ? '' : ' is-out') + '">' +
      (a.img ? '<img src="' + esc(a.img) + '" alt="" width="96" height="72" loading="lazy">' : '<span class="amx-addon__img"></span>') +
      '<span class="amx-addon__t"><b>' + esc(a.t) + '</b><small>' + esc((vt ? vt + ' · ' : '') + (a.av ? T('cfg_one_delivery', 'w jednej dostawie z meblem') : T('cfg_unavail_m', 'chwilowo niedostępny'))) + '</small></span>' +
      (a.av ? '<div class="amx-choice" role="group" aria-label="' + esc(w[2]) + ': ' + T('cfg_pick_one', 'wybierz jedną opcję') + '">' + btn(1, st === true, esc(w[0]) + ' <b>+' + pln(a.p) + '</b>') + btn(0, st === false, esc(w[1])) + '</div>' : '') +
      (err ? '<p class="amx-req-err" role="alert">' + T('cfg_req_err', 'Zaznacz jedną z opcji, żeby dodać łóżko do koszyka.') + '</p>' : '') +
      '</div>';
  }
  const reqLine = (a, st) => [reqWord(a)[2], st === true ? T('cfg_added_m', 'dodany') : st === false ? reqWord(a)[1].toLowerCase() : T('cfg_to_pick', 'do wybrania')];

  // ------------------------------------------------------------------------------------------ inline mode
  function initInline(root, data) {
    const sid = data.section;
    const variants = data.variants || [];
    const byId = new Map(variants.map((v) => [String(v.id), v]));
    let current = byId.get(String(data.current)) || variants[0];
    if (!current) return;
    const picked = new Set(); // add-on variant ids the customer added (with "Dodaj stelaż")
    const declined = new Set(); // required-choice add-ons the customer turned down ("Bez stelaża")
    let err = false;
    const list = root.querySelector('[data-add-list]');
    const note = root.querySelector('[data-add-note]');
    const sum = root.querySelector('[data-add-sum]');
    const items = () => (current.add || []).filter(Boolean);
    const qty = () => {
      const q = document.getElementById('Quantity-' + sid);
      const n = parseInt(q && q.value, 10);
      return n > 0 ? n : 1;
    };
    const chosen = () => items().filter((a) => picked.has(String(a.id)) && a.av);
    const stOf = (a) => (picked.has(String(a.id)) ? true : declined.has(String(a.id)) ? false : undefined);
    const pending = () => items().filter((a) => a.q && a.av && stOf(a) === undefined);

    function paintSum() {
      const its = chosen();
      const sets = its.filter((a) => a.f);
      setPrice(sid, its.length ? {
        add: its.reduce((s, a) => s + a.p, 0),
        n: sets.length,
        addSet: sets.reduce((s, a) => s + a.p, 0),
        base: 0,
        cmp: 0,
        name: data.kind || '',
        items: its.map((a) => [shortT(a.t), a.p]),
      } : null);
      if (!its.length) {
        sum.hidden = true;
        sum.textContent = '';
        return;
      }
      const q = qty();
      sum.hidden = false;
      sum.textContent = F(T('cfg_sum', 'Razem z dodatkami: {amount}{qty} — przed rabatami w koszyku'), { amount: pln((current.p + its.reduce((s, a) => s + a.p, 0)) * q), qty: q > 1 ? ' (' + F(T('cfg_pcs', '{n} szt.'), { n: q }) + ')' : '' });
    }
    function paint() {
      const its = items();
      for (const id of [...picked]) if (!its.some((a) => String(a.id) === id)) picked.delete(id);
      for (const id of [...declined]) if (!its.some((a) => String(a.id) === id)) declined.delete(id);
      if (!pending().length) err = false;
      root.hidden = !its.length;
      list.innerHTML = its.map((a) => (a.q ? reqHtml(a, stOf(a), err && a.av && stOf(a) === undefined) : addonHtml(a, picked.has(String(a.id)) && a.av))).join('');
      const base = its.some(isFrame);
      const ask = its.some((a) => a.q && a.av);
      note.hidden = !base;
      note.textContent = !base ? '' : ask ? T('cfg_note_ask', 'Łóżko nie ma w zestawie stelaża pod materac. Zaznacz, czy chcesz go dokupić, czy zamawiasz łóżko bez stelaża.') : T('cfg_note', 'Łóżko nie ma w zestawie stelaża pod materac. Możesz go dodać tutaj albo użyć własnego.');
      paintSum();
    }
    list.addEventListener('click', (e) => {
      const r = e.target.closest('[data-req]');
      if (r) {
        const id = r.dataset.req;
        const yes = r.dataset.reqV === '1';
        if (yes) { picked.add(id); declined.delete(id); }
        else { declined.add(id); picked.delete(id); }
        paint();
        const back = list.querySelector('[data-req="' + cssq(id) + '"][data-req-v="' + (yes ? 1 : 0) + '"]');
        if (back) back.focus();
        track(yes ? 'stelaz-dodany' : 'stelaz-bez');
        return;
      }
      const b = e.target.closest('[data-addon]');
      if (!b || b.disabled) return;
      const id = b.dataset.addon;
      if (picked.has(id)) picked.delete(id);
      else picked.add(id);
      paint();
      const again = list.querySelector('[data-addon="' + cssq(id) + '"]');
      if (again) again.focus();
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, (ev) => {
        const d = (ev && ev.data) || ev || {};
        if (d.sectionId && d.sectionId !== sid) return;
        const v = d.variant && byId.get(String(d.variant.id));
        if (v && v !== current) {
          current = v;
          paint();
        }
      });
    }
    document.addEventListener('change', (e) => { if (e.target && e.target.id === 'Quantity-' + sid) paintSum(); });
    document.addEventListener('input', (e) => { if (e.target && e.target.id === 'Quantity-' + sid) paintSum(); });

    // Ticked add-ons join the product form's request. Window capture runs before amor-cart.js (document capture),
    // which reads the form synchronously: "id" is swapped for items[n][id] and the form is restored right after.
    window.addEventListener('submit', (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      // getAttribute, not form.id: the form has an input named "id", which shadows the form's id property.
      const isMain = form.getAttribute('id') === 'product-form-' + sid;
      const isSticky = !!form.closest('[data-am-sticky]');
      if (!isMain && !isSticky) return;
      if (pending().length) {
        // Nothing goes to the cart until the customer has chosen: with the stelaż or without it.
        e.preventDefault();
        e.stopImmediatePropagation();
        err = true;
        paint();
        const box = list.querySelector('.amx-addon--req.is-err');
        if (box) {
          box.scrollIntoView({ block: 'center', behavior: 'smooth' });
          const f = box.querySelector('[data-req]');
          if (f) f.focus({ preventScroll: true });
        }
        track('stelaz-brak-wyboru');
        return;
      }
      const its = chosen();
      if (!its.length) return;
      const idInput = form.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) return;
      const own = form.querySelector('input[name="quantity"]');
      const q = parseInt(own && own.value, 10) > 0 ? parseInt(own.value, 10) : qty();
      const extra = [];
      const put = (n, v) => {
        const i = document.createElement('input');
        i.type = 'hidden';
        i.name = n;
        i.value = String(v);
        form.appendChild(i);
        extra.push(i);
      };
      put('items[0][id]', idInput.value);
      put('items[0][quantity]', q);
      its.forEach((a, k) => {
        put('items[' + (k + 1) + '][id]', a.id);
        put('items[' + (k + 1) + '][quantity]', q);
      });
      idInput.disabled = true;
      setTimeout(() => {
        extra.forEach((i) => i.remove());
        idInput.disabled = false;
      }, 0);
    }, true);
    paint();
  }

  // ------------------------------------------------------------------------------------------ full mode
  function initFull(root, data) {
    const sid = data.section;
    const names = data.options || [];
    const cfg = data.cfg || {};
    const steps = (cfg.opcje || []).filter((o) => names.indexOf(o.nazwa) >= 0);
    const sizes = (data.sizes || []).filter(Boolean).map((s) => ({
      ...s,
      media: (s.media || []).filter(Boolean),
      variants: (s.variants || []).map((v) => ({ ...v, add: (v.add || []).filter(Boolean) })),
    })).sort((a, b) => ((a.dims && a.dims[0]) || 0) - ((b.dims && b.dims[0]) || 0));
    if (!sizes.length) return;
    sizes.forEach((s) => { s.key = new Map(s.variants.map((v) => [v.o.join('|'), v])); });
    let si = Math.max(0, sizes.findIndex((s) => s.u === data.current.u));
    const start = sizes[si].variants.find((v) => String(v.id) === String(data.current.v)) || sizes[si].variants[0];
    if (!start) return;
    let sel = start.o.slice();
    let imgIdx = 0;
    const picked = new Set(); // optional add-ons: product titles the customer chose (kept across sizes)
    const reqYes = new Set(); // required choice (stelaż): variant ids added - per id, so another size asks again
    const reqNo = new Set(); // required choice: variant ids turned down
    let reqErr = false;
    const isBed = sizes.some((s) => BED.test(s.t || ''));
    const anyAdd = sizes.some((s) => s.variants.some((v) => v.add.some((a) => !a.q)));
    const anyReq = sizes.some((s) => s.variants.some((v) => v.add.some((a) => a.q)));

    const dlg = root.querySelector('[data-amx-dlg]');
    const q = (s) => dlg.querySelector(s);
    const img = q('[data-amx-img]');
    const thumbs = q('[data-amx-thumbs]');
    const prev = q('[data-amx-prev]');
    const next = q('[data-amx-next]');
    const one = q('[data-amx-step="1"]');
    const two = q('[data-amx-step="2"]');
    const total = q('[data-amx-total]');
    const when = q('[data-amx-when]');
    const out = q('[data-amx-out]');
    const availBtn = q('[data-amx-avail]');
    const addBtn = q('[data-amx-add]');
    const addT = q('[data-amx-add-t]');
    const sumBtn = q('[data-amx-summary]');
    const sumBox = q('[data-amx-sumbox]');
    const pop = q('[data-amx-pop]');
    const popIn = q('[data-amx-pop-in]');
    const tab2 = q('[data-amx-tab="2"]');
    if (tab2 && !anyAdd) tab2.hidden = true;
    const ctaSum = root.querySelector('[data-amx-sum]');
    const hint = root.querySelector('[data-amx-hint]');

    const vOf = (i, o) => sizes[i].key.get((o || sel).join('|'));
    const cv = () => vOf(si);
    const optAdd = (v) => (v ? v.add.filter((a) => !a.q) : []);
    const reqAdd = (v) => (v ? v.add.filter((a) => a.q) : []);
    const reqSt = (a) => (reqYes.has(String(a.id)) ? true : reqNo.has(String(a.id)) ? false : undefined);
    const chosen = () => { const v = cv(); return v ? v.add.filter((a) => a.av && (a.q ? reqYes.has(String(a.id)) : picked.has(a.t))) : []; };
    const pending = () => reqAdd(cv()).filter((a) => a.av && reqSt(a) === undefined);
    const sum = () => { const v = cv(); return v ? v.p + chosen().reduce((s, a) => s + a.p, 0) : 0; };
    const sizeLabel = (s) => {
      const m = /^(\d+)\s*cm$/.exec(String(s.l || '').trim());
      return isBed && m ? m[1] + ' × 200 cm' : s.l || s.t;
    };
    const short = (v) => String(v || '').replace(/\s*\(.*\)\s*$/, '');

    // ---- building blocks ----
    const sec = (no, title, sub, body) =>
      '<section class="amx-sec"><h3 class="amx-h"><span class="amx-no">' + no + '</span>' + esc(title) + '</h3>' + (sub ? '<div class="amx-sub">' + sub + '</div>' : '') + body + '</section>';
    const state = (v) => (v && v.av ? '<span class="amx-st">' + T('cfg_avail', 'Dostępne') + '</span>' : '<span class="amx-st amx-st--out">' + T('common_unavailable_n', 'Chwilowo niedostępne') + '</span>');
    function tile(attrs, label, v, price, on) {
      return '<button type="button" class="amx-tile' + (on ? ' is-on' : '') + (v && v.av ? '' : ' is-out') + '" ' + attrs + ' aria-pressed="' + on + '">' +
        '<span class="amx-tile__t">' + esc(label) + '</span><span class="amx-tile__p">' + price + '</span>' +
        (v && v.av ? '' : '<span class="amx-tile__x">' + T('cfg_unavail_short', 'niedostępne') + '</span>') + (on ? CORNER : '') + '</button>';
    }
    function fabric(oi, w, v, price) {
      const on = sel[oi] === w.v;
      const m = /^(.*?)\s*\(([^)]+)\)\s*$/.exec(w.v);
      const src = w.zdjecie && data.assets && data.assets[w.zdjecie];
      const sw = '<span class="amx-fab__img" style="background-color:' + esc(w.hex || '#ddd') + (src ? ';background-image:url(\'' + esc(src) + '\')' : '') + '"></span>';
      return '<button type="button" class="amx-fab' + (on ? ' is-on' : '') + (v && v.av ? '' : ' is-out') + '" data-opt="' + oi + '" data-val="' + esc(w.v) + '" aria-pressed="' + on + '">' + sw +
        '<span class="amx-fab__b"><b>' + esc(m ? m[1] : w.v) + '</b>' + (m ? '<small>' + esc(m[2]) + '</small>' : '') + state(v) + '</span>' +
        '<span class="amx-fab__p">' + price + '</span>' + (on ? CORNER : '') + '</button>';
    }
    function card(oi, w, v, price) {
      const on = sel[oi] === w.v;
      return '<button type="button" class="amx-card' + (on ? ' is-on' : '') + (v && v.av ? '' : ' is-out') + '" data-opt="' + oi + '" data-val="' + esc(w.v) + '" aria-pressed="' + on + '">' +
        '<span class="amx-card__t"><b>' + esc(w.v) + '</b><span class="amx-card__p">' + price + '</span></span>' +
        (w.opis ? '<span class="amx-card__d">' + esc(w.opis) + '</span>' : '') + state(v) + (on ? CORNER : '') + '</button>';
    }

    function stepOne() {
      let h = '';
      let n = 0;
      if (sizes.length > 1) {
        const vs = sizes.map((s, i) => vOf(i));
        const base = Math.min(...vs.filter(Boolean).map((v) => v.p));
        h += sec(++n, T('cfg_size', 'Rozmiar'), '<span>' + (isBed ? T('cfg_sleep', 'Powierzchnia spania') : T('dims_width', 'Szerokość')) + '</span><button type="button" class="amx-link" data-amx-dims>' + T('cfg_full_dims', 'Pełne wymiary') + '</button>',
          '<div class="amx-tiles">' + sizes.map((s, i) => tile('data-size="' + i + '"', sizeLabel(s), vs[i], vs[i] ? diff(vs[i].p - base) : '—', i === si)).join('') + '</div>');
      }
      steps.forEach((o) => {
        const oi = names.indexOf(o.nazwa);
        const vals = o.typ === 'przelacznik' ? [{ v: o.nie }, { v: o.tak }] : o.wartosci || [];
        const vs = vals.map((w) => { const o2 = sel.slice(); o2[oi] = w.v; return vOf(si, o2); });
        const ok = vs.filter(Boolean);
        const base = ok.length ? Math.min(...ok.map((v) => v.p)) : 0;
        const pr = (k) => (vs[k] ? diff(vs[k].p - base) : '—');
        let body;
        if (o.typ === 'tkanina') body = '<div class="amx-fabs">' + vals.map((w, k) => fabric(oi, w, vs[k], pr(k))).join('') + '</div>';
        else if (o.typ === 'karty') body = '<div class="amx-cards">' + vals.map((w, k) => card(oi, w, vs[k], pr(k))).join('') + '</div>';
        else body = '<div class="amx-tiles amx-tiles--2">' + vals.map((w, k) => tile('data-opt="' + oi + '" data-val="' + esc(w.v) + '"', w.v, vs[k], pr(k), sel[oi] === w.v)).join('') + '</div>';
        h += sec(++n, o.etykieta || o.nazwa, o.info ? '<span>' + esc(o.info) + '</span>' : '', body);
      });
      if (cfg.info) h += '<p class="amx-info">' + esc(cfg.info) + '</p>';
      const v = cv();
      const rq = reqAdd(v);
      if (rq.length) {
        const st = rq.some(isFrame);
        const ask = rq.some((a) => a.av);
        const sub = st ? T('cfg_no_frame_in', 'Ta wersja łóżka nie ma stelaża w zestawie.') + (ask ? ' ' + T('cfg_choose_buy', 'Wybierz, czy chcesz go dokupić.') : '') : '';
        h += '<div data-amx-req>' + sec(++n, st ? T('cfg_frame_title', 'Stelaż pod materac') : T('cfg_addons', 'Dodatki'), sub ? '<span>' + sub + '</span>' : '',
          '<div class="amx-adds">' + rq.map((a) => reqHtml(a, reqSt(a), reqErr && a.av && reqSt(a) === undefined)).join('') + '</div>') + '</div>';
      }
      if (optAdd(v).length) h += '<button type="button" class="amx-btn amx-btn--line amx-next" data-amx-tab="2">' + T('cfg_next_acc', 'Dalej: akcesoria dodatkowe') + '</button>';
      return h;
    }
    function stepTwo() {
      const v = cv();
      const its = optAdd(v);
      if (!its.length) {
        const kit = sel.some((x) => FRAME.test(x) && !/^bez/i.test(x));
        return sec(1, T('cfg_acc', 'Akcesoria dodatkowe'), '', '<p class="amx-empty">' + T('cfg_no_addons', 'Do wybranej konfiguracji nie ma dodatków.') + (kit ? ' ' + T('cfg_frame_incl', 'Stelaż jest już w zestawie.') : '') + '</p>');
      }
      return sec(1, T('cfg_acc', 'Akcesoria dodatkowe'), '<span>' + T('cfg_nothing_auto', 'Nic nie dodajemy automatycznie. Wybierz, co chcesz zamówić razem z łóżkiem.') + '</span>',
        '<div class="amx-adds">' + its.map((a) => addonHtml(a, picked.has(a.t) && a.av)).join('') + '</div>');
    }

    // ---- photos ----
    // The photos of size i with the options o: with a fabric option only that fabric's photos (the alt text names
    // the fabric code), the variant's own photo first.
    function galleryFor(i, o) {
      let list = sizes[i].media;
      steps.filter((st) => st.typ === 'tkanina').forEach((st) => {
        const m = /\(([^)]+)\)/.exec(o[names.indexOf(st.nazwa)] || '');
        if (!m) return;
        const code = m[1];
        const family = code.replace(/\s*\d+\s*$/, '');
        const own = list.filter((x) => !x.a || x.a.indexOf(family) < 0 || x.a.indexOf(code) >= 0);
        if (own.length) list = own;
      });
      const v = vOf(i, o);
      const k = v && v.m ? list.findIndex((x) => x.id === v.m) : -1;
      return k > 0 ? [list[k]].concat(list.filter((x, j) => j !== k)) : list;
    }
    const gallery = () => galleryFor(si, sel);

    // The stage shows 1600 px versions, which Shopify's image CDN makes on the first request for each photo.
    // Measured 14.10.2026 on PERLA: a photo not yet asked for in that size took 0.60-0.67 s to the first byte
    // (cf-cache-status MISS, server-timing imageryProcess 0.23-0.45 s), a cached one 25 ms; the files are 57-96 kB.
    // Fetching a photo only on click made each arrow or thumbnail click wait that long with nothing changing on
    // the stage. Now: the first photos load on hover or touch of "Skonfiguruj i kup", the whole gallery loads in
    // the background once the configurator is open (with Save-Data only the two neighbours), a fabric's or size's
    // first photo loads on hover of its tile, the stage switches only to a loaded and decoded photo (the last one
    // asked for wins), a spinner shows when that takes over 150 ms, and the thumbnails are rebuilt only when the
    // set of photos changes.
    const warmed = new Map(); // url -> {im, ok: Promise<boolean>}
    const saveData = !!(navigator.connection && navigator.connection.saveData);
    function warm(url, hi) {
      if (!url) return null;
      let w = warmed.get(url);
      if (!w) {
        const im = new Image();
        im.decoding = 'async';
        if ('fetchPriority' in im) im.fetchPriority = hi ? 'high' : 'low';
        const ok = new Promise((res) => {
          im.onload = () => res(true);
          im.onerror = () => {
            warmed.delete(url);
            res(false);
          };
        });
        im.src = url;
        w = { im, ok };
        warmed.set(url, w);
      }
      return w;
    }
    // The photos next to number "from" first (next, previous, then further out); max: how many.
    function warmAround(g, from, max) {
      const n = g.length;
      const order = [];
      for (let d = 1; d < n; d++) {
        [(from + d) % n, (from - d + n) % n].forEach((k) => { if (k !== from && order.indexOf(k) < 0) order.push(k); });
      }
      order.slice(0, saveData ? Math.min(2, max || 2) : max || n).forEach((k) => warm(g[k].s));
    }
    const stageBox = img.parentElement;
    let want = '';
    let spinT = 0;
    function stageTo(m) {
      if (!m || !m.s) return;
      const url = m.s;
      want = url;
      clearTimeout(spinT);
      if (img.getAttribute('src') === url) {
        stageBox.classList.remove('is-loading');
        img.alt = m.a || '';
        return;
      }
      const w = warm(url, true);
      spinT = setTimeout(() => { if (want === url) stageBox.classList.add('is-loading'); }, 150);
      w.ok.then((ok) => (ok && w.im.decode ? w.im.decode().catch(() => {}) : null)).then(() => {
        if (want !== url) return;
        clearTimeout(spinT);
        stageBox.classList.remove('is-loading');
        img.src = url;
        img.alt = m.a || '';
      });
    }
    function thumbInView() {
      const b = thumbs.querySelector('.amx-th.is-on');
      if (!b || thumbs.scrollWidth <= thumbs.clientWidth) return;
      const tr = thumbs.getBoundingClientRect();
      const br = b.getBoundingClientRect();
      if (br.left < tr.left) thumbs.scrollLeft -= tr.left - br.left + 8;
      else if (br.right > tr.right) thumbs.scrollLeft += br.right - tr.right + 8;
    }
    let gKey = '';
    function paintStage(keep) {
      const g = gallery();
      if (!keep || imgIdx >= g.length) imgIdx = 0;
      const key = g.map((x) => x.id).join(',');
      if (key !== gKey) {
        gKey = key;
        thumbs.innerHTML = g.map((x, i) => '<button type="button" class="amx-th" data-amx-th="' + i + '" aria-label="' + F(T('cfg_photo_n', 'Zdjęcie {i} z {n}'), { i: i + 1, n: g.length }) + '"><img src="' + esc(x.t) + '" alt="" loading="lazy"></button>').join('');
        thumbs.hidden = g.length < 2;
        prev.hidden = next.hidden = g.length < 2;
      }
      [...thumbs.children].forEach((b, i) => {
        const on = i === imgIdx;
        b.classList.toggle('is-on', on);
        if (on) b.setAttribute('aria-current', 'true');
        else b.removeAttribute('aria-current');
      });
      stageTo(g[imgIdx]);
      if (!dlg.hidden) {
        warmAround(g, imgIdx);
        thumbInView();
      }
    }

    // ---- bar, summary, page ----
    function nearest() {
      const score = (v) => v.o.reduce((s, x, i) => s + (x === sel[i] ? 1 : 0), 0);
      const order = sizes.map((s, i) => i).sort((a, b) => Math.abs(a - si) - Math.abs(b - si));
      for (const i of order) {
        const ok = sizes[i].variants.filter((v) => v.av).sort((a, b) => score(b) - score(a));
        if (ok.length) return { i, v: ok[0] };
      }
      return null;
    }
    function summaryHtml() {
      const v = cv();
      const rows = [[T('cfg_size', 'Rozmiar'), sizeLabel(sizes[si])]].concat(steps.map((o) => [o.etykieta || o.nazwa, sel[names.indexOf(o.nazwa)]]))
        .concat(reqAdd(v).filter((a) => a.av).map((a) => reqLine(a, reqSt(a))));
      return '<p class="amx-sum__h">' + T('cfg_chosen', 'Wybrane opcje') + '</p><dl class="amx-sum__l">' + rows.map((r) => '<dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd>').join('') + '</dl>' +
        '<ul class="amx-sum__p"><li><span>' + esc(sizes[si].t) + '</span><b>' + (v ? pln(v.p) : '—') + '</b></li>' +
        chosen().map((a) => '<li><span>' + esc(a.t) + (a.vt && a.vt !== 'Default Title' ? ', ' + esc(a.vt) : '') + '</span><b>+' + pln(a.p) + '</b></li>').join('') +
        '<li class="amx-sum__tot"><span>' + T('zs_total', 'Razem') + '</span><b>' + pln(sum()) + '</b></li></ul><p class="amx-sum__n">' + T('cfg_sum_note', 'Rabat za zestaw i koszt dostawy policzy koszyk.') + '</p>';
    }
    function paintBar() {
      const v = cv();
      const ok = !!(v && v.av);
      total.textContent = v ? pln(sum()) : '—';
      when.hidden = !ok;
      out.hidden = ok;
      availBtn.hidden = ok || !nearest();
      addBtn.disabled = !ok;
      addT.textContent = ok ? T('common_add_to_cart', 'Dodaj do koszyka') : T('cfg_unavail_cap', 'Niedostępne');
      if (!sumBox.hidden) sumBox.innerHTML = summaryHtml();
      paintPrice();
    }
    // The price on the product page: the configured variant (another size too) with the chosen add-ons.
    function paintPrice() {
      const v = cv();
      if (!v) return;
      const its = chosen();
      const kind = data.kind || '';
      const other = sizes[si].u !== data.current.u;
      const sets = its.filter((a) => a.f);
      setPrice(sid, {
        add: its.reduce((s, a) => s + a.p, 0),
        n: sets.length,
        addSet: sets.reduce((s, a) => s + a.p, 0),
        base: v.p,
        cmp: v.c || 0,
        name: other ? F(T('cfg_yours', 'Twoja konfiguracja ({what}):'), { what: (kind ? kind.toLowerCase() + ' ' : '') + sizeLabel(sizes[si]) }) : its.length ? kind : '',
        items: its.map((a) => [shortT(a.t), a.p]),
      });
    }
    function paintCta() {
      if (!ctaSum) return;
      const v = cv();
      const rows = (sizes.length > 1 ? [[T('cfg_size', 'Rozmiar'), sizeLabel(sizes[si])]] : []).concat(steps.map((o) => [o.etykieta || o.nazwa, short(sel[names.indexOf(o.nazwa)])]))
        .concat(reqAdd(v).filter((a) => a.av).map((a) => reqLine(a, reqSt(a))));
      ctaSum.innerHTML = rows.map((r) => '<div><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd></div>').join('') +
        '<div class="amx-cta__price"><dt>' + T('cart_price', 'Cena') + '</dt><dd><b>' + (v ? pln(sum()) : '—') + '</b>' + (v && v.av ? '' : ' · ' + T('cfg_unavail_n', 'chwilowo niedostępne')) + '</dd></div>';
    }
    // Size tiles on the product page (snippets/am-pdp-sizes) link to the sibling's variant with the same options.
    function paintSizeLinks() {
      const key = sel.join('|');
      document.querySelectorAll('.am-pdp-var a.am-pdp-var__opt').forEach((a) => {
        let path;
        try {
          path = new URL(a.getAttribute('href'), location.href).pathname;
        } catch (e) {
          return;
        }
        const s = sizes.find((x) => x.u === path);
        if (!s) return;
        const v = s.key.get(key);
        a.setAttribute('href', v ? s.u + '?variant=' + v.id : s.u);
      });
    }
    let paintSticky = () => {};
    function paintAll(keepImg) {
      one.innerHTML = stepOne();
      two.innerHTML = stepTwo();
      paintStage(keepImg);
      paintBar();
      paintCta();
      paintSticky();
      paintSizeLinks();
    }
    function refocus(sel2) {
      const el = dlg.querySelector(sel2);
      if (el) el.focus({ preventScroll: true });
    }

    // ---- choosing ----
    function chooseSize(i) {
      if (i === si || !sizes[i]) return;
      si = i;
      reqErr = false;
      paintAll();
      refocus('[data-size="' + i + '"]');
    }
    function chooseOpt(oi, val) {
      if (sel[oi] === val) return;
      sel[oi] = val;
      reqErr = false;
      paintAll();
      refocus('[data-opt="' + oi + '"][data-val="' + cssq(val) + '"]');
    }
    function setTab(n) {
      const s2 = n === 2 && !(tab2 && tab2.hidden);
      one.hidden = s2;
      two.hidden = !s2;
      dlg.querySelectorAll('[data-amx-tab].amx-tab').forEach((t) => t.setAttribute('aria-selected', String(t.dataset.amxTab === (s2 ? '2' : '1'))));
      const panel = dlg.querySelector('.amx-panel');
      if (panel) panel.scrollTop = 0;
      if (window.matchMedia && window.matchMedia('(max-width: 989px)').matches) {
        const head = dlg.querySelector('.amx-head');
        if (head) dlg.scrollTop = Math.max(0, head.offsetTop);
      }
    }

    // ---- pop-ups (dimensions, zoom) and summary ----
    function showPop(html, cls) {
      popIn.innerHTML = html;
      pop.className = 'amx-pop' + (cls ? ' amx-pop--' + cls : '');
      pop.hidden = false;
      const x = pop.querySelector('[data-amx-pop-close]');
      if (x) x.focus();
    }
    const hidePop = () => { pop.hidden = true; popIn.innerHTML = ''; };
    function dims() {
      const s = sizes[si];
      const d = s.dims || [];
      // the producer's drawing: alt "Rysunek techniczny …" (Czech translation: "Technický nákres …")
      const draw = s.media.find((x) => /^(Rysunek techniczny|Technický nákres)/i.test(x.a || ''));
      const rows = [];
      if (d[0]) rows.push([T('dims_width', 'Szerokość'), num(d[0]) + ' cm']);
      if (d[1]) rows.push([T('dims_height', 'Wysokość'), num(d[1]) + ' cm']);
      if (d[2]) rows.push([isBed ? T('dims_length', 'Długość') : T('dims_depth', 'Głębokość'), num(d[2]) + ' cm']);
      if (isBed) rows.push([T('cfg_sleep', 'Powierzchnia spania'), sizeLabel(s)]);
      showPop('<p class="amx-pop__h">' + T('cfg_full_dims', 'Pełne wymiary') + ' · ' + esc(sizeLabel(s)) + '</p>' + (draw ? '<img class="amx-pop__img" src="' + esc(draw.s) + '" alt="' + esc(draw.a) + '">' : '') +
        '<dl class="amx-dims">' + rows.map((r) => '<div><dt>' + r[0] + '</dt><dd>' + esc(r[1]) + '</dd></div>').join('') + '</dl>', 'dims');
    }
    function toggleSummary(force) {
      const show = typeof force === 'boolean' ? force : sumBox.hidden;
      sumBox.hidden = !show;
      sumBtn.setAttribute('aria-expanded', String(show));
      if (show) sumBox.innerHTML = summaryHtml();
    }

    // ---- open / close ----
    let lastFocus = null;
    function trap(e) {
      const f = [...dlg.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])')].filter((el) => !el.disabled && el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function onKey(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        if (!pop.hidden) hidePop();
        else if (!sumBox.hidden) toggleSummary(false);
        else close();
      } else if (e.key === 'Tab') trap(e);
      else if ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && document.activeElement === img) move(e.key === 'ArrowLeft' ? -1 : 1);
    }
    function open() {
      if (dlg.parentElement !== document.body) document.body.appendChild(dlg);
      lastFocus = document.activeElement;
      dlg.hidden = false;
      document.documentElement.classList.add('amx-lock');
      setTab(1);
      reqErr = false;
      paintAll();
      document.addEventListener('keydown', onKey);
      const x = dlg.querySelector('[data-amx-close]');
      if (x) x.focus();
      track('konfigurator-otwarty');
    }
    function syncPage() {
      if (sizes[si].u !== data.current.u) return;
      const vs = document.getElementById('variant-selects-' + sid);
      if (!vs) return;
      let last = null;
      names.forEach((nm, i) => {
        const input = vs.querySelector('input[type="radio"][data-option-name="' + cssq(nm) + '"][value="' + cssq(sel[i]) + '"]');
        if (input && !input.checked) {
          input.checked = true;
          last = input;
        }
      });
      if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function close() {
      if (dlg.hidden) return;
      dlg.hidden = true;
      hidePop();
      toggleSummary(false);
      document.documentElement.classList.remove('amx-lock');
      document.removeEventListener('keydown', onKey);
      syncPage();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function move(d) {
      const g = gallery();
      if (g.length < 2) return;
      imgIdx = (imgIdx + d + g.length) % g.length;
      paintStage(true);
    }
    function addToCart() {
      const v = cv();
      if (!v || !v.av) return;
      if (pending().length) {
        // The stelaż needs an answer first: show the step, mark it and put the focus on its first button.
        reqErr = true;
        setTab(1);
        paintAll(true);
        const step = dlg.querySelector('[data-amx-req]');
        if (step) {
          step.scrollIntoView({ block: 'start', behavior: 'smooth' });
          const f = step.querySelector('.amx-addon--req.is-err [data-req]') || step.querySelector('[data-req]');
          if (f) f.focus({ preventScroll: true });
        }
        track('stelaz-brak-wyboru');
        return;
      }
      const form = document.createElement('form');
      form.method = 'post';
      form.action = ROOT + 'cart/add';
      form.hidden = true;
      form.setAttribute('data-am-handle', sizes[si].h || '');
      const put = (n, val) => {
        const i = document.createElement('input');
        i.type = 'hidden';
        i.name = n;
        i.value = String(val);
        form.appendChild(i);
      };
      put('items[0][id]', v.id);
      put('items[0][quantity]', 1);
      chosen().forEach((a, k) => {
        put('items[' + (k + 1) + '][id]', a.id);
        put('items[' + (k + 1) + '][quantity]', 1);
      });
      document.body.appendChild(form);
      close();
      track('konfigurator-koszyk');
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    }

    // ---- events ----
    root.addEventListener('click', (e) => { if (e.target.closest('[data-amx-open]')) open(); });
    // Hover, focus or touch of "Skonfiguruj i kup" (touch of the mobile sticky bar too): the first photos start loading.
    const warmStart = () => {
      const g = gallery();
      if (!g.length) return;
      warm(g[0].s, true);
      warmAround(g, 0, 2);
    };
    root.querySelectorAll('[data-amx-open]').forEach((b) => ['pointerenter', 'focus', 'touchstart'].forEach((ev) => b.addEventListener(ev, warmStart, { once: true, passive: true })));
    // Hover of a size or fabric tile: the first photo of that choice starts loading.
    dlg.addEventListener('pointerover', (e) => {
      const b = e.target.closest('[data-size],[data-opt]');
      if (!b) return;
      let g = null;
      if (b.dataset.size !== undefined) {
        if (sizes[Number(b.dataset.size)]) g = galleryFor(Number(b.dataset.size), sel);
      } else {
        const o2 = sel.slice();
        o2[Number(b.dataset.opt)] = b.dataset.val;
        g = galleryFor(si, o2);
      }
      if (g && g[0]) warm(g[0].s);
    });
    dlg.addEventListener('click', (e) => {
      const t = e.target;
      let b;
      if (t.closest('[data-amx-close]')) return close();
      if (t.closest('[data-amx-pop-close]') || t === pop || t.closest('.amx-pop--zoom')) return hidePop();
      if ((b = t.closest('[data-amx-tab]'))) return setTab(Number(b.dataset.amxTab));
      if ((b = t.closest('[data-size]'))) return chooseSize(Number(b.dataset.size));
      if ((b = t.closest('[data-opt]'))) return chooseOpt(Number(b.dataset.opt), b.dataset.val);
      if ((b = t.closest('[data-req]'))) {
        const v = cv();
        const a = v && v.add.find((x) => String(x.id) === b.dataset.req);
        if (!a) return;
        const yes = b.dataset.reqV === '1';
        if (yes) { reqYes.add(String(a.id)); reqNo.delete(String(a.id)); }
        else { reqNo.add(String(a.id)); reqYes.delete(String(a.id)); }
        if (!pending().length) reqErr = false;
        one.innerHTML = stepOne();
        paintBar();
        paintCta();
        refocus('[data-req="' + cssq(String(a.id)) + '"][data-req-v="' + (yes ? 1 : 0) + '"]');
        track(yes ? 'stelaz-dodany' : 'stelaz-bez');
        return;
      }
      if ((b = t.closest('[data-addon]'))) {
        if (b.disabled) return;
        const v = cv();
        const a = v && v.add.find((x) => String(x.id) === b.dataset.addon);
        if (!a) return;
        if (picked.has(a.t)) picked.delete(a.t);
        else picked.add(a.t);
        two.innerHTML = stepTwo();
        paintBar();
        paintCta();
        refocus('[data-addon="' + cssq(String(a.id)) + '"]');
        return;
      }
      if ((b = t.closest('[data-amx-th]'))) { imgIdx = Number(b.dataset.amxTh); return paintStage(true); }
      if (t.closest('[data-amx-prev]')) return move(-1);
      if (t.closest('[data-amx-next]')) return move(1);
      if (t.closest('[data-amx-dims]')) return dims();
      if (t.closest('[data-amx-zoom]')) return showPop('<img class="amx-pop__zoom" src="' + esc(img.currentSrc || img.src) + '" alt="' + esc(img.alt) + '">', 'zoom');
      if (t.closest('[data-amx-summary]')) return toggleSummary();
      if (t.closest('[data-amx-avail]')) {
        const n = nearest();
        if (n) { si = n.i; sel = n.v.o.slice(); paintAll(); }
        return;
      }
      if (t.closest('[data-amx-add]')) return addToCart();
    });

    // Mobile sticky bar: it opens the configurator instead of adding the first variant.
    const bar = document.querySelector('[data-am-sticky]');
    if (bar) {
      const sb = bar.querySelector('button[type="submit"]');
      if (sb) sb.textContent = T('common_cfg_buy', 'Skonfiguruj i kup');
      bar.addEventListener('touchstart', warmStart, { once: true, passive: true });
      window.addEventListener('submit', (e) => {
        const f = e.target;
        if (f instanceof HTMLFormElement && f.closest('[data-am-sticky]')) {
          e.preventDefault();
          e.stopImmediatePropagation();
          open();
        }
      }, true);
      // When the bar shows is decided in assets/amor.js (13.10.2026): after the gallery, while this button is off screen.
      paintSticky = () => {
        const pb = bar.querySelector('b');
        const v = cv();
        if (pb && v) pb.textContent = pln(sum());
      };
    }

    if (hint) {
      // option labels in the accusative ("wersję", Czech "verzi"): AMOR_I18N.cfg_acc_map, "Label=word|…"
      const acc = {};
      T('cfg_acc_map', 'Wersja=wersję|Kolor tkaniny=kolor tkaniny|Oświetlenie LED=oświetlenie LED').split('|').forEach((x) => { const kv = x.split('='); if (kv.length === 2) acc[kv[0]] = kv[1]; });
      const parts = (sizes.length > 1 ? [T('cfg_w_size', 'rozmiar')] : []).concat(steps.map((o) => acc[o.etykieta] || String(o.etykieta || o.nazwa).toLowerCase())).concat(anyReq ? [T('cfg_w_frame', 'stelaż')] : []).concat(anyAdd ? [T('cfg_w_addons', 'dodatki')] : []);
      const txt = parts.length > 1 ? parts.slice(0, -1).join(', ') + ' ' + T('common_and', 'i') + ' ' + parts[parts.length - 1] : parts[0] || T('cfg_w_options', 'opcje');
      hint.textContent = txt.charAt(0).toUpperCase() + txt.slice(1) + ' ' + T('cfg_hint_tail', 'wybierzesz w konfiguratorze.');
    }

    document.documentElement.classList.add('amx-on');
    root.hidden = false;
    paintCta();
    paintSticky();
    paintSizeLinks();
    paintPrice();
  }

  function init(root) {
    if (root.dataset.amxReady) return;
    root.dataset.amxReady = '1';
    let data;
    try {
      data = JSON.parse(root.querySelector('[data-amx-json]').textContent);
    } catch (e) {
      console.error('[am-config] bad data', e);
      return;
    }
    if (data.mode === 'full') initFull(root, data);
    else initInline(root, data);
  }
  function boot() {
    document.querySelectorAll('[data-amx]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();